export default __webpack_public_path__ + "static/media/premium@2x.d55cfdef.png";